import { ProblemProgress as ProblemProgressType } from '@yandex-int/k-common/typings';
import b from 'b_';
import { Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import React from 'react';
import { connect } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';

import { EmptyStateContainer } from '../__empty-state/stats__empty-state.container';
import StatsProgress from '../__stats-progress/stats__stats-progress';
// @ts-ignore
import COLORS from '../constants.scss';
import * as selectors from '../selectors';

import './stats__student-stats.scss';

interface StoreProps {
    shouldShowEmptyState: boolean;
    stats: ProblemProgressType | null;
    time: string;
    points: number | string;
    shouldDisplayPoints: boolean;
}

interface Props extends StoreProps {}

export const StudentStats = (props: Props) => {
    const { shouldShowEmptyState, stats, time, shouldDisplayPoints, points } = props;

    if (shouldShowEmptyState) {
        return <EmptyStateContainer />;
    }

    return (
        <>
            <div className={b('stats', 'item', { type: 'student-stats' })}>
                <StatsProgress
                    failTextId="lessonView.stats.failResult"
                    stats={stats}
                    successTextId="lessonView.stats.successResult"
                    unknownTextId="lessonView.stats.unknownResult"
                />
            </div>
            <div className={b('stats', 'item', { type: 'time' })}>
                <Text size={Text.SIZE.XXL}>{time}</Text>
                <Text
                    color={COLORS.lessonStatText}
                    id="lessonView.stats.studentTime"
                    type={TEXT_MARKUP_TYPE.MARKDOWN}
                />
            </div>
            {shouldDisplayPoints && (
                <div className={b('stats', 'item', { type: 'points' })}>
                    <Text size={Text.SIZE.XXL}>{points}</Text>
                    <Text
                        color={COLORS.lessonStatText}
                        id="lessonView.stats.studentPoints"
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                    />
                </div>
            )}
        </>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    return {
        shouldShowEmptyState: selectors.getAreStudentStatsEmpty(storeState),
        stats: selectors.getStudentStats(storeState),
        time: selectors.getStudentTime(storeState),
        points: selectors.getStudentPoints(storeState),
        shouldDisplayPoints: lessonSelectors.getShouldDisplayPoints(storeState),
    };
};

export default connect(mapStateToProps)(StudentStats);
